import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import ContactEntity from '@/entities/api/users/contact'

export const fetchContacts = async (token: string) => {
	const response = await axios.get(`${API_URL}/contact`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const updateContactById = async (token : string, id : string, contact : Partial<ContactEntity>) => {
	const response = await axios.patch(`${API_URL}/contact/${id}`,
		{
			status : contact.status,
			response : contact.response
		}, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}